import { useEffect, useEffectEvent } from 'react';
import { useLocation } from 'react-router';

import { useNavigate } from '#hooks/useNavigate';

import { hayArchivoCompartido } from './archivoCompartido';

/**
 * Si se compartió un extracto con la app cerrada y Rumbo abrió primero el
 * puerto (elegir barco), al entrar al barco se lleva a /compartido para que
 * Gavi lo suba. Una vez por apertura.
 */
export function useIrACompartido() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const mirar = useEffectEvent(async () => {
    if (pathname !== '/compartido' && (await hayArchivoCompartido())) {
      void navigate('/compartido');
    }
  });

  // Solo al abrir el barco: después, /compartido lo consume.
  useEffect(() => {
    void mirar();
  }, []);
}
